import React from 'react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-24 pb-16 bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Професійне інформаційне агентство
          </h1>
          <p className="text-xl sm:text-2xl mb-4 text-primary-100">
            ТОВ "ІНФОРМАЦІЙНЕ АГЕНТСТВО "АЛІБІ.НЕТ.ЮА"
          </p>
          <p className="text-lg sm:text-xl mb-8 text-primary-50 max-w-2xl mx-auto">
            Надаємо комплексні інформаційні послуги для бізнесу та приватних осіб. 
            Достовірна інформація, швидкий результат, конфіденційність.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToContact}
              className="bg-white text-primary-700 px-8 py-3 rounded-lg font-semibold hover:bg-primary-50 transition-colors shadow-lg"
            >
              Замовити послугу
            </button>
            <button 
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="bg-primary-800 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-900 transition-colors border-2 border-white"
            >
              Наші послуги
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
